/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ThemeResource } from '../models/ThemeResource';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SongLibraryThemesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Display all themes.
     * @returns any OK
     * @throws ApiError
     */
    public getThemes({
        search,
        inUseOnly,
    }: {
        /**
         * Search themes by name.
         */
        search?: string,
        /**
         * Only return themes that are in use.
         */
        inUseOnly?: boolean,
    }): CancelablePromise<{
        data: Array<ThemeResource>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/song-library/themes',
            query: {
                'search': search,
                'in-use-only': inUseOnly,
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

}
